/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_TestingInputs */



/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Connections_TestingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_testing = /** @type {((inputs?: Connections_TestingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_TestingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bezig met controleren…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérification…")
	return /** @type {LocalizedString} */ ("Checking…")
});